"use client"
import { useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { BiBriefcase, BiRightArrow } from "react-icons/bi"

export default function ProjetCard({ project, stats, index }) {
    const navigate = useNavigate()

    const handleSelectProject = async (project) => {
        localStorage.setItem("selec-projet", project.id)
        navigate(`/projet/${project.id}`)
    }

    return (
        <motion.div className="card h-100 shadow-lg border-0"
            onClick={() => handleSelectProject(project)}
            style={{ cursor: "pointer" }}
            whileHover={{ background: "linear-gradient(145deg, #ffffff, #f8f9fa)" }}>
            <div className="card-body text-center p-3">
                <motion.div className="rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center"
                    style={{ width: "50px", height: "50px", background: `linear-gradient(45deg, hsl(${(index * 137.5) % 360}, 70%, 60%), hsl(${(index * 137.5 + 60) % 360}, 70%, 70%))` }}
                    whileHover={{ scale: 1.1, rotate: 360 }}
                    transition={{ type: "spring", stiffness: 300, damping: 20 }}>
                    <BiBriefcase className="fs-2 text-white" />
                </motion.div>

                <motion.h6 className="card-title mb-2" whileHover={{ scale: 1.05 }}>
                    {project.name || project.nom}
                </motion.h6>

                <div className="row text-center">
                    <div className="col-6">
                        <div className="border-end">
                            <motion.div className="fs-5 fw-bold text-primary" whileHover={{ scale: 1.2 }}>{stats.classeurs}</motion.div>
                            <small className="text-muted">Classeurs</small>
                        </div>
                    </div>
                    <div className="col-6">
                        <motion.div className="fs-5 fw-bold text-success" whileHover={{ scale: 1.2 }}>{stats.feuilles}</motion.div>
                        <small className="text-muted">Feuilles</small>
                    </div>
                </div>
            </div>

            <motion.div className="card-footer bg-transparent border py-1" whileHover={{ backgroundColor: "rgba(0,0,0,0.02)" }}>
                <div className="btn btn-sm btn-link link-primary text-decoration-none text-muted w-100 d-flex align-items-center justify-content-center">
                    <BiRightArrow className="me-1" />
                    Cliquer pour ouvrir
                </div>
            </motion.div>
        </motion.div>
    )
}
